import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ArchivalComponent } from './archival.component';
import { ArchivalConfirmComponent } from './archivalconfirm/archival-confirm.component';
import { EntityRelationsService } from 'app/entities/relations/entity-relations.service';
import {
    AutoCompleteModule,
    DataTableModule,
    ConfirmDialogModule
} from 'primeng/primeng';

@NgModule({
    declarations: [ArchivalComponent, ArchivalConfirmComponent],
    imports: [
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        DataTableModule,
        FlexLayoutModule,
        AutoCompleteModule,
        ConfirmDialogModule,
        SharedModule
    ],
    providers: [EntityRelationsService],
    entryComponents: [
        ArchivalComponent,
        ArchivalConfirmComponent
    ]

})

/**
 * Main module for the archival managements.
 *
 * @author mohit.khurana@vernuso.com (Mohit Khurana)
*/

export class ArchivalModule { }





// WEBPACK FOOTER //
// ./src/app/admin/archival/archival.module.ts